import gql from 'graphql-tag';

const QUERY_ESIM = gql`
  query esim($esimId: ID!) {
    esim(esimId: $esimId) {
      id
      status
      compatibleBrand
        compatibleModel
      createdBy {
        id
        firstName
        lastName
      }
      createdAt
      license {
        id
        isAllowedDual
        licenseType
        name
        productId
        storage
      }
    }
  }
`;

const QUERY_EMAIL_BY_ESIM = gql`
  query esim($esimId: ID!) {
      esim(esimId: $esimId) {
        user {
          id
          email
        }
      }
    }
`;

const ESIM_QUERY = (key = 0) => {
  switch (key) {
    case 0:
      return QUERY_ESIM;
    case 1:
      return QUERY_EMAIL_BY_ESIM;
    default:
      return QUERY_ESIM;
  }
};

export default ESIM_QUERY;
